import React from 'react'

import ExpandablePanel from '../controls/ExpandablePanel'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import { controlHasError } from '../../lib/errorHandler'

class SiedzibaR2 extends React.Component {
  state = {
    wojewodztwa: [
      'DOLNOŚLĄSKIE',
      'KUJAWSKO-POMORSKIE',
      'LUBELSKIE',
      'LUBUSKIE',
      'ŁÓDZKIE',
      'MAŁOPOLSKIE',
      'MAZOWIECKIE',
      'OPOLSKIE',
      'PODKARPACKIE',
      'PODLASKIE',
      'POMORSKIE',
      'ŚLĄSKIE',
      'ŚWIĘTOKRZYSKIE',
      'WARMIŃSKO-MAZURSKIE',
      'WIELKOPOLSKIE',
      'ZACHODNIOPOMORSKIE',
    ],
  }

  render() {
    const isForeign = !!this.props.data.SiedzibaZagraniczna
    const hasValue = (value) =>
      value !== undefined && value !== null && value !== ''
    return (
      <ExpandablePanel title="SIEDZIBA">
        <form autoComplete="off" className="siedzibaR2">
          <RadioGroup
            row
            className="wariantSiedziby"
            name="wariantSiedziby"
            value={isForeign ? 'zagraniczny' : 'polski'}
            onChange={(e) => {
              const isNextForeign = e.target.value === 'zagraniczny'
              this.props.onSetSectionData(
                'SiedzibaZagraniczna',
                isNextForeign,
              )
              const fieldsToClear = [
                'Wojewodztwo',
                'Powiat',
                'Gmina',
                'Ulica',
                'NrDomu',
                'NrLokalu',
                'Miejscowosc',
                'KodPocztowy',
                'KodKraju',
              ]
              fieldsToClear.forEach((field) =>
                this.props.onSetSectionData(field, ''),
              )
            }}
          >
            <FormControlLabel
              value="polski"
              control={<Radio color="primary" />}
              label="adres polski"
            />
            <FormControlLabel
              value="zagraniczny"
              control={<Radio color="primary" />}
              label="adres zagraniczny"
            />
          </RadioGroup>
          {!isForeign ? (
            <div className="siedzibaR2Polska">
              <div className="firstRow">
                <FormControl component="fieldset">
                  <InputLabel shrink={hasValue(this.props.data.Wojewodztwo)}>Województwo</InputLabel>
                  <Select
                    error={controlHasError(this.props.errors, 'Wojewodztwo')}
                    name="Wojewodztwo"
                    value={this.props.data.Wojewodztwo}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  >
                    {this.state.wojewodztwa.map(w => (
                      <MenuItem value={w} key={w}>
                        {w.toLocaleLowerCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(
                      this.props.errors,
                      'Powiat',
                      this.props.data.Powiat,
                    )}
                    name="Powiat"
                    label="Powiat"
                    title={this.props.data.Powiat}
                    value={this.props.data.Powiat}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.Powiat),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(
                      this.props.errors,
                      'Gmina',
                      this.props.data.Gmina,
                    )}
                    name="Gmina"
                    label="Gmina"
                    title={this.props.data.Gmina}
                    value={this.props.data.Gmina}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.Gmina),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
              </div>
              <div className="secondRow">
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'Ulica')}
                    name="Ulica"
                    label="Ulica"
                    title={this.props.data.Ulica}
                    value={this.props.data.Ulica}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.Ulica),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'NrDomu')}
                    name="NrDomu"
                    label="Nr domu"
                    title={this.props.data.NrDomu}
                    value={this.props.data.NrDomu}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.NrDomu),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'NrLokalu')}
                    name="NrLokalu"
                    label="Nr lokalu"
                    title={this.props.data.NrLokalu}
                    value={this.props.data.NrLokalu}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.NrLokalu),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
              </div>
              <div className="thirdRow">
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(
                      this.props.errors,
                      'Miejscowosc',
                      this.props.data.Miejscowosc,
                    )}
                    name="Miejscowosc"
                    label="Miejscowość"
                    title={this.props.data.Miejscowosc}
                    value={this.props.data.Miejscowosc}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.Miejscowosc),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'KodPocztowy')}
                    name="KodPocztowy"
                    label="Kod pocztowy"
                    title={this.props.data.KodPocztowy}
                    value={this.props.data.KodPocztowy}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.KodPocztowy),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
              </div>
            </div>
          ) : (
            <div className="siedzibaR2Zagraniczna">
              <div className="secondRow">
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'Ulica')}
                    name="Ulica"
                    label="Ulica"
                    title={this.props.data.Ulica}
                    value={this.props.data.Ulica}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.Ulica),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'NrDomu')}
                    name="NrDomu"
                    label="Nr domu"
                    title={this.props.data.NrDomu}
                    value={this.props.data.NrDomu}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.NrDomu),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'NrLokalu')}
                    name="NrLokalu"
                    label="Nr lokalu"
                    title={this.props.data.NrLokalu}
                    value={this.props.data.NrLokalu}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.NrLokalu),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
              </div>
              <div className="thirdRow">
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'KodPocztowy')}
                    name="KodPocztowy"
                    label="Kod pocztowy"
                    title={this.props.data.KodPocztowy}
                    value={this.props.data.KodPocztowy}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.KodPocztowy),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(
                      this.props.errors,
                      'Miejscowosc',
                      this.props.data.Miejscowosc,
                    )}
                    name="Miejscowosc"
                    label="Miejscowość"
                    title={this.props.data.Miejscowosc}
                    value={this.props.data.Miejscowosc}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.Miejscowosc),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
                <FormControl component="fieldset">
                  <TextField
                    error={controlHasError(this.props.errors, 'KodKraju')}
                    name="KodKraju"
                    label="Kod kraju"
                    title={this.props.data.KodKraju}
                    value={this.props.data.KodKraju}
                    InputLabelProps={{
                      shrink: hasValue(this.props.data.KodKraju),
                    }}
                    onChange={e =>
                      this.props.onSetSectionData(e.target.name, e.target.value)
                    }
                  />
                </FormControl>
              </div>
            </div>
          )}
        </form>
      </ExpandablePanel>
    )
  }
}

export default SiedzibaR2
